import { ArticleModel } from '@/types/models/ArticleModel';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from '@inertiajs/react';
import { Fragment } from 'react';

const PatientPostItem = ({ name, authors, excerpt, time, slug, hero, therapeutic_areas, id, is_pin_protected }: ArticleModel) => {
    const newPath = hero
        ? `/patient${hero.replace('.' + hero.split('.').pop(), `-size-768.webp`)}/${id}/article`
        : '';

    return (
        <article>
            <div className="flex items-center gap-x-2 mb-2 mt-3 justify-between">
                {!!is_pin_protected && <div className="size-10 bg-accordorange rounded-full flex items-center justify-center"><Icon icon={`ph:lock-key`} className="text-arcticMist origin-bottom animate-lock-wiggle-loop" width={24} /></div>}
            </div>
            {authors &&
                <p className="maxMd:hidden block text-14 leading-18 text-arcticMist mb-2">{authors.length === 1 ? 'Autor: ' : 'Autorzy: '}
                    {authors.map((author, i) => (
                        <span key={i} className="text-accordorange">{`${author.degree} ${author.name_surname}`} {(authors.length > 1 && i + 1 < authors.length) ? ', ' : ''}</span>
                    ))}
                </p>
            }
            <div className="flex gap-x-8 maxMd:flex-wrap items-start">
                <div className='max-w-[calc(100%_-_192px)] maxMd:max-w-full w-full maxMd:order-2'>
                    {authors &&
                        <p className="maxMd:block hidden text-14 leading-18 text-arcticMist mb-4">{authors.length === 1 ? 'Autor: ' : 'Autorzy: '}
                            {authors.map((author, i) => (
                                <span key={i} className="text-accordorange">{`${author.degree} ${author.name_surname}`} {(authors.length > 1 && i + 1 < authors.length) ? ', ' : ''}</span>
                            ))}
                        </p>
                    }
                    <Link href={route('front.patient.articleSingle', { article: slug })} as='button' className='max-w-[calc(100%_-_192px)] maxMd:max-w-full w-full text-left' type='button'>
                        <p className='text-arcticMist h4 font-semibold mb-2'>{name}</p>

                        <p className='text-arcticMist text-body mb-6 maxMd:mb-4' dangerouslySetInnerHTML={{ __html: excerpt.replace(/\n/g, '<br/>') }}></p>
                    </Link>
                    <p className='text-arcticMist text-14 leading-18 maxMd:block hidden mb-4'>czas czytania <span className='text-accordorange'>{time} min</span></p>
                    <div className="flex gap-x-6 items-center justify-between">
                        <div className="flex gap-x-6 items-center maxMd:gap-x-2">
                            {therapeutic_areas && therapeutic_areas.map((th, i) => (
                                <Fragment key={i}>
                                    <div className={`small-cat-tag tag-${th.name.toLowerCase()}`}>
                                        {th.name}
                                    </div>
                                </Fragment>
                            ))}
                            <p className='text-arcticMist text-14 leading-18 maxMd:hidden'>czas czytania <span className='text-accordorange'>{time} min</span></p>
                        </div>
                    </div>
                </div>
                <Link href={route('front.patient.articleSingle', { article: slug })} as='button' className='maxMd:order-1'>
                    <img src={newPath} alt="Post" width={192} loading='lazy' height={192} className='object-cover w-[192px] h-[192px] maxMd:w-full maxMd:h-auto maxMd:object-contain maxMd:mb-2' />
                </Link>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="2px" className="my-10 maxMd:hidden">
                <pattern id="custom-border-pattern" width="18" height="2" patternUnits="userSpaceOnUse">
                    <rect x="0" y="0" width="2" height="2" fill="#393ABF" />
                    <rect x="4" y="0" width="14" height="2" fill="transparent" />
                </pattern>
                <rect width="100%" height="2px" fill="url(#custom-border-pattern)" />
            </svg>
        </article>
    )
}

export default PatientPostItem;